<template lang="pug">
  tr
    item-dialog(
      :genuses="genuses"
      :box-types="boxTypes"
      :units="units"
      @complete="onDialogSaved($event, 'item')"
      @entermove-refresh-request="entermoveRefresh"
      @closeDialog="dialog.item.show = false"
      :dialog="dialog.item.show"
      :search="dialog.item.search"
    )
    variety-dialog(
      :items="items"
      :item="contactProduct.item"
      :dialog="dialog.variety.show"
      :search="dialog.variety.search"
      @complete="onVarietySaved"
      @closeDialog="dialog.variety.show=false"
      @entermove-refresh-request="entermoveRefresh"
    )
    size-dialog(
      :items="items"
      :item="contactProduct.item"
      :dialog="dialog.size.show"
      :search="dialog.size.search"
      @entermove-refresh-request="entermoveRefresh"
      @closeDialog="dialog.size.show = false"
      @complete="onSizeSaved"
    )
    td.w10per.td-left.td-right.td-bottom
      v-checkbox(v-model="isChecked" @change="$emit('check', index, isChecked)")
    fieldset(:class="contactProduct.allocate_chart_details ? 'hasAllocatedChart' : ''")
      td.w40per.td-right.td-bottom
        v-combobox(
        autocomplete="off"
        :items="items"
        :placeholder="$t('contact.info.item')"
        item-text="name"
        item-value="id"
        return-object
        :value="contactProduct.item && contactProduct.item.id !== null ? contactProduct.item : contactProduct.item_input"
        hide-details
        @change="UpdateSizeAndLoadVariety({item: $event})"
        :class="validateForObject(contactProduct.item) ? '' : 'red-text'"
        :search-input.sync="dialog.item.search"
        :menu-props="{ 'closeOnContentClick' : true}"
        em="a.7"
        :filter="customFilter"
        ref="items")
          template(slot="no-data")
            div.pa-1.pl-2
              span {{$t('common.messages.no_data', {name: dialog.item.search}) }} <br>
              a(@click.prevent="openDialog('item')") {{$t('common.messages.add_new', {name: $t('contact.info.item')}) }}

        v-combobox(
          autocomplete="off"
          :items="sizes"
          :placeholder="$t('contact.info.size')"
          :menu-props="{ 'closeOnContentClick' : true}"
          :search-input.sync="dialog.size.search"
          item-text="name"
          item-value="id"
          return-object
          hide-details
          :class="validateForObject(contactProduct.size) ? '' : 'red-text'"
          :value="contactProduct.size && contactProduct.size.id !== null ? contactProduct.size : formatSizeToDisplay(contactProduct.size_input)"
          @change="UpdateInfoSize({size: $event})"
          em="a.9"
          ref="sizes")
          template(slot="no-data")
            div.pa-1.pl-2
              span {{$t('common.messages.no_data', {name: dialog.size.search}) }} <br>
              a(@click.prevent="openDialog('size')" v-if="checkItemForAddNew()") {{$t('common.messages.add_new', {name: $t('contact.info.size')}) }}
        v-combobox(
          autocomplete="off"
          :items="countries"
          :placeholder="$t('contact.info.country')"
          item-text="name"
          item-value="id"
          :value="contactProduct.country && contactProduct.country.id !== null ? contactProduct.country : contactProduct.country_input"
          @change="UpdateInfoCountry({country: $event})"
          return-object
          hide-details
          ref="countries"
          em="a.11"
        )
      td.w40per.td-right.td-bottom
        v-combobox(
        autocomplete="off"
        :items="varieties"
        :placeholder="$t('contact.info.variety')"
        :search-input.sync="dialog.variety.search"
        item-text="name"
        item-value="id"
        return-object
        :value="contactProduct.variety && contactProduct.variety.id !== null ? contactProduct.variety : contactProduct.variety_input"
        hide-details
        :class="validateForObject(contactProduct.variety) ? '' : 'red-text'"
        @change="UpdateInfoAndLoadSize({variety: $event})"
        :menu-props="{ 'closeOnContentClick' : true}"
        em="a.8"
        ref="varieties")
          template(slot="no-data")
            div.pa-1.pl-2
              span {{$t('common.messages.no_data', {name: dialog.variety.search}) }} <br>
              a(@click.prevent="openDialog('variety')" v-if="checkItemForAddNew()") {{$t('common.messages.add_new', {name: $t('contact.info.variety')}) }}
        v-text-field.min-height-auto(
          hide-details
          :placeholder="$t('contact.info.variety_note')"
          :value="contactProduct.note"
          @change="updateContactProducts({note: $event, target: contactProduct})"
          em="a.10"
        )
        v-combobox(
          autocomplete="off"
          :items="suppliers"
          :placeholder="$t('contact.info.supplier')"
          item-text="name"
          item-value="id"
          :value="contactProduct.supplier && contactProduct.supplier.id !== null ? contactProduct.supplier : contactProduct.supplier_input"
          @change="UpdateInfoSupplier({supplier: $event})"
          return-object
          hide-details
          ref="suppliers"
          em="a.12"
        )
</template>

<script>
import ItemDialog from '@/app/pages/Master/Item/append'
import VarietyDialog from '@/app/pages/Master/Variety/append'
import SizeDialog from '@/app/pages/Master/Size/append'
import customFilter from '@/app/mixins/utils'
import {mapGetters, mapMutations, mapActions} from 'vuex'
import Entermove from '@/common/mixins/entermove'

export default {
  components: {ItemDialog, VarietyDialog, SizeDialog},
  data: () => ({
    isChecked: false,
    varieties: [],
    sizes: [],
    dialog: {
      item: {
        show: false,
        key: 'items',
        search: ''
      },
      variety: {
        show: false,
        key: 'varieties',
        search: ''
      },
      size: {
        show: false,
        key: 'size',
        search: ''
      }
    }
  }),
  props: {
    contactProduct: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    genuses: {
      type: Array,
      required: true
    },
    units: {
      type: Array,
      required: true
    },
    boxTypes: {
      type: Array,
      required: true
    }
  },
  mixins: [customFilter, Entermove],
  computed: {
    ...mapGetters('app/ct', ['info'])
  },
  created () {
    if (this.contactProduct.item && !isNaN(this.contactProduct.item.id)) {
      this.loadVariety(true)
    }
  },
  methods: {
    ...mapMutations('app/ct', ['updateInfo', 'addItemToArrayState', 'updateContactProducts']),
    ...mapActions('app/ct', ['updateInfo']),
    UpdateSizeAndLoadVariety (brand) {
      if (brand.item.id) {
        this.updateContactProducts({...brand, target: this.contactProduct})
        this.updateContactProducts({item_input: null, target: this.contactProduct})
      } else {
        this.updateContactProducts({item: {name: brand.item}, target: this.contactProduct})
        this.updateContactProducts({item_input: brand.item, target: this.contactProduct})
      }
      this.loadVariety()
    },
    validateForObject (m) {
      if (!m || !m.id) {
        return false
      } else {
        return typeof m === 'object'
      }
    },
    UpdateInfoSize (item) {
      if (item.size.id) {
        this.updateContactProducts({...item, target: this.contactProduct})
        this.updateContactProducts({size_input: null, target: this.contactProduct})
      } else {
        this.updateContactProducts({size: {name: item.size}, target: this.contactProduct})
        this.updateContactProducts({size_input: item.size, target: this.contactProduct})
      }
    },
    UpdateInfoCountry (item) {
      if (item.country.id) {
        this.updateContactProducts({...item, target: this.contactProduct})
      } else {
        this.updateContactProducts({country_input: item.country, target: this.contactProduct})
      }
    },
    UpdateInfoAndLoadSize (item) {
      if (item.variety.id) {
        this.updateContactProducts({...item, target: this.contactProduct})
        this.updateContactProducts({variety_input: null, target: this.contactProduct})
      } else {
        this.updateContactProducts({variety: {name: item.variety}, target: this.contactProduct})
        this.updateContactProducts({variety_input: item.variety, target: this.contactProduct})
      }
    },
    checkItemForAddNew () {
      if (this.contactProduct.item && this.contactProduct.item.id) {
        return true
      }
      return false
    },
    UpdateInfoSupplier (item) {
      if (item.supplier.id) {
        this.updateContactProducts({...item, target: this.contactProduct})
      } else {
        this.updateContactProducts({supplier_input: item.supplier, target: this.contactProduct})
      }
    },
    loadVariety (update = false) {
      if (!this.contactProduct.item || typeof this.contactProduct.item !== 'object' || !this.contactProduct.item.id) {
        this.varieties = []
        this.sizes = []
        this.updateContactProducts({variety: null, target: this.contactProduct})
        this.updateContactProducts({size: null, target: this.contactProduct})
        return true
      }
      let query = this.$url.buildQuery({
        item: this.contactProduct.item.id // item id
      })
      this.$ajax.get(`/variety/list?${query}`)
        .then((response) => {
          this.varieties = response.data
          // reset data
          if (!update) {
            this.updateContactProducts({variety: null, target: this.contactProduct})
            this.updateContactProducts({size: null, target: this.contactProduct})
          }
        })
        .catch((messages, error) => {
          messages.map((message) => this.$toastr.error(message))
        })

      this.$ajax.get(`/size/list?${query}`)
        .then((response) => {
          this.sizes = response.data
          // reset data
          if (!update) {
            this.updateContactProducts({size: null, target: this.contactProduct})
          }
        })
        .catch((messages, error) => {
          messages.map((message) => this.$toastr.error(message))
        })
    },
    onDialogSaved (payload, name) {
      this.dialog[name].show = false
      this.updateContactProducts({item: payload, target: this.contactProduct})
      this.addItemToArrayState({key: this.dialog[name].key, value: payload})
    },
    onVarietySaved (payload) {
      this.dialog['variety'].show = false
      this.varieties.push(payload)
      this.updateContactProducts({variety: payload, target: this.contactProduct})
    },
    onSizeSaved (payload) {
      this.dialog['size'].show = false
      this.updateContactProducts({size: payload, target: this.contactProduct})
      this.sizes.push(payload)
    },
    openDialog (name) {
      this.dialog[name].show = true
    },
    // 2cm$3号$4輪$5本立
    formatSizeToDisplay (size) {
      if (typeof size !== 'undefined' && size !== null) {
        if (size.includes('$')) {
          let newSize = size.split('$')
          return newSize.join('')
        }
      }
      return size
    }
  }
}
</script>

<style scoped lang="stylus">
.red-text
  >>>input
    color: red !important;
fieldset {
  border: 1px solid #DDDDDD;
}
.hasAllocatedChart{
  background-color: aliceblue;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Contact/ProductItem.vue